import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormEvent, ReactNode } from 'react';
import styled from 'styled-components';

export const StyledTicketHeader = styled.div`
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
`;

export const StyledHeading = styled.h1`
    padding: 0;
`;

export const StyledTicketCount = styled.span`
    font-size: 16px;
    margin-left: 6px;
`;

export const StyledButtonGroup = styled.div`
    display: flex;
    .gi-button: last-child {
        margin-right: 0.5rem;
    }
    button:not([disabled]):focus {
        outline: none;
    }
`;

export const StyledClaimNewTicketButton = styled.div`
    .gi-button svg {
        margin-right: 0;
    }
`;

export const StyledWorkgroupList = styled.ul`
    list-style: none;
    margin: 0;
    padding: 8px 0;
`;

export const StyledWorkgroupListItem = styled.li`
    padding: 4px 8px;
    display: flex;
    align-items: center;
    cursor: pointer;
`;

export const StyledHeaderButtonGroup = styled.div`
    display: flex;
    justify-content: space-between;
    alignitems: center;
    margin-bottom: 1rem;
    flex-direction: row-reverse;
`;

export const StyledDownloadButton = styled.div`
    .usa-button {
        margin-right: 0;
    }

    .gi-button svg {
        margin-right: 0;
    }
`;

export const StyledTabWrapper = styled.div`
    display: flex;
    gap: 10px;
    margin-bottom: 6px;
`;

export const StyledButton = styled.div`
    width: 100%;
`;

export const StyledTab = styled.span<{
    onClick: () => void;
    children: ReactNode;
    disabled?: boolean;
}>`
    color: ${({ theme, disabled }) => (disabled ? theme.grayLight : theme.primaryDark)};
    cursor: pointer;
`;

export const StyledContentCard = styled.div`
    box-sizing: border-box;
    border: 1px solid #dddde5;
    border-radius: 8px;
    padding: 24px 24px 32px 24px;
    margin-bottom: 24px;
    background-color: ${({ theme }) => theme.defaultWhite};
    transition: 0.1s;
    box-shadow: 0 8px 16px rgba(175, 175, 193, 0.16);
    overflow: visible !important;
`;

export const StyledForm = styled.form<{
    onSubmit: (e: FormEvent<HTMLFormElement>) => void;
    children: ReactNode;
}>`
    margin-bottom: 60px;
`;

export const FlexContainer = styled.div`
    display: flex;
    gap: 20px;
    flex-direction: column;
    justify-content: flex-start;
`;

export const FlexRow = styled.div`
    display: flex;
    gap: 80px;
    flex-direction: row;
`;

export const FlexRowEnd = styled(FlexRow)`
    justify-content: end;
`;

export const StyledAdvanceSearchControl = styled(FlexRowEnd)`
    margin-top: 24px;
`;

export const FlexItem = styled.div<{ className?: string; highlight?: boolean }>`
    display: flex;
    justify-content: start;
    flex-direction: column;
    flex: 1;
    max-width: calc(25% - 60px);

    .gi-input,
    .gi-dropdown {
        margin: 0;
    }
    .gi-dropdown {
        margin-bottom: 0;
        align-items: flex-start;
        flex-direction: column;
        width: 100%;
    }

    .gi-button {
        height: fit-content;
        width: 100%;
    }
    .gi-button:active {
        outline: none;
    }
    .gi-input__input {
        width: 100%;
    }
    .gi-dropdown__label {
        width: 100%;
        padding: 0;
        display: inherit;
    }
    .gi-dropdown__select {
        width: 100%;
    }
    .gi-datepicker {
        margin-bottom: 0;
    }
    .gi-input__label {
        display: flex;
        padding: 0;
    }
    .react-datepicker__input-container input {
        width: 100%;
    }
    .react-datepicker-wrapper {
        width: 100%;
    }
    button:not([disabled]):focus {
        outline: none;
    }

    .autocomplete-input,
    .autocomplete-menu {
        width: 100%;
    }

    .autocomplete-search-wrapper {
        width: 100%;
        position: relative;
        margin-bottom: 0;
    }
    .autocomplete-menu {
        border: 1px solid ${({ theme }) => theme.gray7};
        border-radius: 0.25rem;
        max-height: 200px;
        overflow-y: auto;
        background-color: ${({ theme }) => theme.defaultWhite};
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        position: absolute;
        left: 0;
        right: 0;
        z-index: 10;
    }

    .autocomplete-search-wrapper .search-input-label {
        font-weight: normal;
        font-size: 16px;
    }
    .autocomplete-search-wrapper .autocomplete-input {
        margin-top: 5px;
    }
    ${({ theme, highlight }) =>
        highlight &&
        `
            background: ${theme.infoLightest} !important;
        `}
`;

export const StyledControlButton = styled.div`
    display: flex;
    justify-content: end;
    flex-direction: column;
    width: 220px;
`;

export const StyledAction = styled.div`
    display: flex;
    gap: 5px;
    color: ${({ theme }) => theme.primaryDark};
`;

export const StyledActionList = styled.ul`
    list-style: none;
    margin: 0;
    padding: 8px 0;
    cursor: pointer;

    li:hover {
        background-color: ${({ theme }) => theme.gray10};
    }
`;

export const StyledPopoverli = styled.li<{ onClick: () => void; children: ReactNode }>`
    color: ${({ theme }) => theme.primaryDark};
    padding: 8px 16px;
    display: 'flex';
    alignitems: 'center';
    cursor: 'pointer';
`;

export const StyledActionPopoverIcon = styled(FontAwesomeIcon)`
    margin-right: 8px;
`;

export const StyledModal = styled.div`
    .gi-input {
        text-align: center;
    }
    .gi-modal__content {
        width: 500px;
    }
    .gi-input {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
    }
    .gi-input input {
        width: 100%;
    }
    .grid-row {
        flex-direction: column;
        width: 100%;
    }
    textarea {
        width: 100%;
        height: 36px;
        resize: none;
        padding: 5px;
    }

    .gi-input__label {
        padding: 0;
    }
    .gi-modal__controls {
        display: flex;
        justify-content: space-between;
    }
    .verify-complete-modal .gi-modal__body {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .gi-modal__body label {
        width: 100% !important;
    }
    .verify-complete-modal textarea {
        height: 130px;
    }

    .complete-ticket-modal textarea {
        height: auto;
    }

    .complete-ticket-modal label {
        width: 100%;
    }

    .reassign-ticket-modal .gi-DROPDOWN {
        flex-direction: row;
        justify-content: center;
        gap: 20px;
    }
    .reassign-ticket-modal .gi-modal__body label {
        width: auto !important;
        align-content: center;
    }

    .error-modal .gi-modal__body,
    .error-modal .gi-modal__controls {
        display: flex;
        justify-content: center;
    }
`;

export const StyledInputContainer = styled.div`
    display: flex;
    flex-direction: column;
    > input {
        margin-top: 0px;
        text-align: left;

        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        /* Remove Firefox spin buttons */
        &[type='number'] {
            -moz-appearance: textfield;
        }
    }

    label {
        font-size: 15px;
        color: ${({ theme }) => theme.gray2};
    }

    .cancelTicketReason {
        height: 60px;
    }
`;

export const StyledCharacterReamining = styled.div<{ id: string; children: ReactNode }>`
    color: ${({ theme }) => theme.gray4};
    font-size: 15px;
`;

export const StyledError = styled.div`
    color: red;
    font-size: 12px;
    margin-top: 4px;
`;

export const StyledFlexCenter = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const StyledRecordsNotFound = styled(StyledFlexCenter)`
    font-size: 18px;
    font-weight: 600;
    color: ${({ theme }) => theme.primaryDark};
`;

export const StyledLabel = styled.label``;
export const StyledTextarea = styled.textarea``;
